import {useAutocomplete} from "@/app-autocomplete/providers/AutocompleteProvider.tsx";

export function useCollection(collectionName:string){
    const {
        autocompleteState: { collections },
    } = useAutocomplete();

    const sourceEntry = collections.find(({ source }) => source.sourceId === collectionName);
    const items = sourceEntry?.items || [];

    return {
        items,
        source: sourceEntry?.source,
    };
}